import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  fetchStandaloneModeSuccess,
  fetchStandaloneModeFailure,
  updateStandaloneModeSuccess,
  updateStandaloneModeFailure,
} from './standalone-mode-actions';

export function* doFetchStandaloneMode(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'standaloneMode',
      options: {
        errorMessage: 'Could not fetch Standalone Mode',
        retryAction: action,
      },
    });
    yield put(fetchStandaloneModeSuccess(results));
  } catch (err) {
    yield put(fetchStandaloneModeFailure(err));
  }
}

export function* doUpdateStandaloneMode(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'standaloneMode',
      options: {
        method: 'PUT',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not update Standalone Mode',
        retryAction: action,
      },
    });
    yield put(updateStandaloneModeSuccess(results));
  } catch (err) {
    yield put(updateStandaloneModeFailure(err));
  }
}

function* watchFetchStandaloneMode() {
  yield takeLatest(actionTypes.FETCH_STANDALONE_MODE_REQUEST, doFetchStandaloneMode);
}

function* watchUpdateStandaloneMode() {
  yield takeLatest(actionTypes.UPDATE_STANDALONE_MODE_REQUEST, doUpdateStandaloneMode);
}

export default [
  fork(watchFetchStandaloneMode),
  fork(watchUpdateStandaloneMode),
];
